import InputTypes from 'utils/enums/inputTypes';
import { IField } from 'utils/interfaces/IField';

const courses: IField[] = [
    {
        presentation: 'Nome',
        label: 'Nome do curso',
        name: 'name',
        type: InputTypes.text,
        columns: 3
    },
    {
        presentation: 'Selecione um período letivo',
        label: 'Período letivo',
        name: 'schoolPeriod',
        type: InputTypes.simpleSelect,
        columns: 3
    }
];

export default courses;
